import { Dialog, Transition } from "@headlessui/react";
import { Fragment } from "react";
import { useTranslation } from "react-i18next";

import { automationTestIds } from "../../testing/automationTestIds";

function AccountNotActiveModal({ isOpen, message, onClose }) {
  const { t } = useTranslation();

  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-30"
        onClose={onClose}
        id={automationTestIds.accountNotActiveModal}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-200"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-150"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div
            className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
            id={automationTestIds.accountNotActiveModalBackdrop}
          />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-200"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-150"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel
                className="w-full max-w-md transform overflow-hidden rounded-[1.25rem] bg-cfSecondary p-8 text-left align-middle shadow-xl transition-all relative"
                id={automationTestIds.accountNotActiveModalPanel}
              >
                <button
                  type="button"
                  onClick={onClose}
                  className="absolute top-4 right-4 text-cfSignInSignUpInputPlaceholderText hover:text-cfSignInSignUpHeadingText focus:outline-none text-xl leading-none"
                  aria-label={t("authPages:account_not_active_close")}
                  id={automationTestIds.accountNotActiveModalClose}
                >
                  &#10005;
                </button>

                <Dialog.Title
                  as="h3"
                  className="text-2xl font-medium leading-7 text-cfSignInSignUpHeadingText pr-8"
                  id={automationTestIds.accountNotActiveModalTitle}
                >
                  {t("authPages:account_not_active_title")}
                </Dialog.Title>

                <p
                  className="mt-4 text-base leading-6 text-cfSignInSignUpIntroMessageText"
                  id={automationTestIds.accountNotActiveModalMessage}
                >
                  {message}
                </p>

                <div className="mt-8">
                  <button
                    type="button"
                    onClick={onClose}
                    className="rounded-xl text-base font-semibold py-1 px-5 text-cfSecondary w-full h-11 bg-cfButton hover:bg-cfPrimaryDark transition-colors duration-200"
                    id={automationTestIds.accountNotActiveModalOk}
                  >
                    {t("authPages:account_not_active_ok")}
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
}

export default AccountNotActiveModal;
